import { mapActions, mapGetters } from 'vuex'

import { DocumentationCategories, DocumentationFiles, ServicesNestJS } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import { getSocket, services, touch } from '@/utils'

import render from './render'

export default {
  name: 'DefaultLayout',

  mixins: [ touch() ],

  data() {
    return {
      showSidebar: false
    }
  },

  computed: {
    ...mapGetters({ isLoggedAs: 'login/isLoggedAs' }),

    buttonsStyle() {
      let cols = 2
      if (this.viewport.breakpoint.mdUp) {
        cols = 5
      }

      return `grid-template-columns: repeat(${cols}, auto)`
    },

    pathToTitle() {
      const paths = this.$route.path.split('/')
      const documentationPaths = [ ...Object.values(DocumentationCategories), ...Object.values(DocumentationFiles) ]
      const excludePaths = [ 'admin', 'routes', 'other', 'documents', 'messageProcessing', ...documentationPaths ]

      if (paths[1] === 'playground' && [ 'components', 'services' ].includes(paths[2])) {
        excludePaths.push(paths[2])
      }

      return paths
        .filter(path => {
          return Boolean(path) && !isUUID(path) && !excludePaths.includes(path)
        })
        .join('.')
    },

    routeNameForSwagger() {
      const paths = this.$route.path.split('/')

      return paths[1]
    },
    routeHasSwagger() {
      const services = Object.values(ServicesNestJS)

      return services.includes(this.routeNameForSwagger)
    }
  },

  watch: {
    $route: {
      handler() {
        if (this.viewport.breakpoint.smDown) {
          this.showSidebar = false
        }
      },
      deep: true
    },

    viewport: {
      handler() {
        if (this.viewport.breakpoint.smDown) {
          this.showSidebar = false
        } else {
          this.showSidebar = true
        }
      },
      deep: true
    }
  },

  mounted() {
    const socket = getSocket()
    socket?.on(`${services.users}.updated`, data => {
      if (this.account.id === data.id) {
        this.getAccount(this.account.id)
      }
    })
    socket?.on(`${services.settingsUser}.updated`, () => {
      return this.getGlobalSettings()
    })
    socket?.on(`${services.settingsSite}.updated`, () => {
      return this.getGlobalSettings()
    })

    this.showSidebar = this.viewport.breakpoint.mdUp
  },

  methods: {
    ...mapActions({
      loginAs: 'login/loginAs',
      logout: 'login/logout',
      getAccount: 'account/getAccount',
      getGlobalSettings: 'settings/getGlobalSettings',
      setShowPaymentDialog: 'payments/setShowPaymentDialog'
    }),

    leftSwipeCallback() {
      this.showSidebar = false
    },
    rightSwipeCallback() {
      this.showSidebar = true
    }
  },

  render
}
